/**
 * VH-83: Category dropdown + "compatible only" checkbox for the recipes list.
 */

import { useTranslation } from 'react-i18next'

export default function RecipeCategoryFilter({
  categories = [],
  categoryId,
  onCategoryChange,
  compatibleOnly,
  onCompatibleOnlyChange,
  search,
  onSearchChange,
}) {
  const { t } = useTranslation()

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
      <div>
        <label className="form-label" htmlFor="recipe-search">
          {t('recipes.search')}
        </label>
        <input
          id="recipe-search"
          type="text"
          value={search || ''}
          onChange={(e) => onSearchChange?.(e.target.value)}
          className="form-input w-full"
        />
      </div>
      <div>
        <label className="form-label" htmlFor="recipe-category">
          {t('recipes.category')}
        </label>
        <select
          id="recipe-category"
          value={categoryId || ''}
          onChange={(e) =>
            onCategoryChange?.(e.target.value ? parseInt(e.target.value, 10) : null)
          }
          className="form-input w-full"
        >
          <option value="">{t('recipes.categoryAll')}</option>
          {categories.map((c) => (
            <option key={c.id} value={c.id}>
              {c.display_name}
            </option>
          ))}
        </select>
      </div>
      <label className="inline-flex items-center gap-2 cursor-pointer pb-2">
        <input
          type="checkbox"
          checked={Boolean(compatibleOnly)}
          onChange={(e) => onCompatibleOnlyChange?.(e.target.checked)}
          className="text-primary-600 focus:ring-primary-500"
        />
        <span className="text-sm text-gray-700">
          {t('recipes.compatibleOnly')}
        </span>
      </label>
    </div>
  )
}
